<template>
	<div id="app" class="app">
		<div class="m-top">
			<div class="m-top-logo">
				<img src="./assets/images/logo@2x.png" alt="" />
				<h1>圆通廉正举报</h1>
			</div>
		</div>
		<div class="m-cont">
			<div class="m-cont-sect" v-if="step === 1">
				<Intro></Intro>
				<div class="m-cont-sect-checked">
					<el-checkbox v-model="formObj.checked"
						>我已确认以上信息，确认提交</el-checkbox
					>
				</div>
				<div class="m-cont-sect-button">
					<el-button
						:disabled="!formObj.checked"
						type="primary"
						@click="handleNext()"
						>举报</el-button
					>
				</div>
			</div>
			<div class="m-cont-sect" v-else-if="step === 2">
				<el-form ref="form" :model="formObj" label-width="120px">
					<!-- 举报人 -->
					<div class="m-cont-sect-form">
						<div class="form-title">
							<h3>举报人基本信息</h3>
						</div>
						<div class="form-cont">
							<el-form-item
								label="姓名"
								size="small"
								prop="reporterName"
								:rules="rules.name"
							>
								<el-input
									v-model="formObj.reporterName"
									maxlength="30"
									placeholder="请输入姓名"
									clearable
								></el-input>
							</el-form-item>
							<el-form-item
								label="联系电话"
								size="small"
								prop="reporterPhone1"
								:rules="{
									required: true,
									message: '联系电话不能为空',
									trigger: ['blur', 'change'],
								}"
							>
								<el-input
									v-model="formObj.reporterPhone1"
									maxlength="30"
									placeholder="请输入联系电话"
									clearable
								></el-input>
                <div class="form-cont-tip">
                  <p>该号码作为举报奖励联系通道</p>
                </div>
							</el-form-item>
						</div>
					</div>
					<!-- 被举报人 -->
					<div class="m-cont-sect-form">
						<div class="form-title">
							<h3>被举报人基本信息</h3>
						</div>
						<div
							class="form-cont"
							v-for="(item, index) in formObj.list"
							:key="index"
						>
							<el-form-item
								label="姓名"
								size="small"
								:prop="'list.' + index + '.name'"
								:rules="rules.name"
							>
								<el-input
									v-model="item.name"
									maxlength="30"
									placeholder="请输入姓名"
									clearable
								></el-input>
							</el-form-item>
							<el-form-item
								label="单位部门/职务"
								size="small"
                maxlength="30"
								:prop="'list.' + index + '.department'"
								:rules="{
									required: true,
									message: '单位部门不能为空',
									trigger: ['blur', 'change'],
								}"
							>
								<el-input
									v-model="item.department"
									maxlength="30"
									placeholder="如：浦东部长"
									clearable
								></el-input>
							</el-form-item>
							<el-form-item label="联系电话" size="small">
								<el-input
									v-model="item.phone"
                  maxlength="100"
									placeholder="可填多个号码，逗号隔开"
									clearable
								></el-input>
							</el-form-item>
							<el-form-item label="微信号" size="small">
								<el-input
									v-model="item.weChat"
									maxlength="30"
									placeholder="请输入微信号"
									clearable
								></el-input>
							</el-form-item>
						</div>
					</div>
					<!-- 举报内容 -->
					<div class="m-cont-sect-form">
						<div class="form-title">
							<h3>举报内容</h3>
						</div>
						<div class="form-cont">
							<el-form-item
								label="举报内容"
								size="small"
								style="width: 100%"
								prop="content"
								:rules="{
									required: true,
									message: '请填写举报内容',
									trigger: ['blur', 'change'],
								}"
							>
								<el-input
									type="textarea"
									:maxlength="5000"
									:autosize="{ minRows: 10, maxRows: 100 }"
									v-model="formObj.content"
									clearable
								></el-input>
								<div class="form-cont-tip">
									<p>限5000字，严禁使用禁忌用语或恶语伤人等</p>
								</div>
							</el-form-item>
							<el-form-item label="举证资料" size="small" style="width: 100%">
								<el-upload
									class="form-upload"
									:action="
										baseUrl +
										'/incorruptible/accusation/file/upload?reportId=&position=0'
									"
									:multiple="true"
									:on-remove="handleRemove"
									:on-success="handleSuccess"
									:before-upload="handleBeforeupload"
									:show-file-list="true"
								>
									<el-button size="small" type="primary">点击上传</el-button>
									<template #tip>
										<div class="el-upload__tip">
											附件最大为20M，可上传格式为gif、jpg、png、jpeg、bmp、doc、ppt、xls、xlsx、docx、pptx、zip、rar、pdf
										</div>
									</template>
								</el-upload>
							</el-form-item>
						</div>
					</div>
					<div class="m-cont-sect-button">
						<el-button type="default" @click="handlePrev()">上一步</el-button>
						<el-button
							type="primary"
							:disabled="saveStatus"
							@click="submitForm('form')"
							>确认提交</el-button
						>
					</div>
				</el-form>
			</div>
			<div class="m-cont-sect" v-else-if="step === 3">
				<div class="m-result">
					<i class="el-icon-circle-check"></i>
					<p>提交成功</p>
					<div class="m-cont-sect-button">
						<el-button type="primary" @click="reloadPage()">关闭</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import config from "./config";
	import Intro from "./components/Intro.vue";
	export default {
		name: "App",
		components: {
			Intro,
		},
		data() {
			var validateName =(rule, value, callback)=> {
				var pattern_Ch = new RegExp("^[\u4E00-\u9FA5]+$");
				var pattern_En = new RegExp("^[A-Za-z]+$");
				if(!pattern_Ch.test(value) && !pattern_En.test(value)){
					callback('请输入中英文')
				}else{
					callback();
				}
			}
			return {
				title: "圆通廉正纪察中心举报平台",
				baseUrl: config.baseUrl,
				// 步骤标识
				step: 1,
				// 举报信息
				formObj: {
					checked: false,
					reporterName: "", // 姓名
					reporterDepartment: "", // 单位部门
					reporterPhone1: "", // 联系电话1
					list: [
						{
							name: "",
							department: "",
							phone: "",
							weChat: "",
						},
					],
					reportSource: 1, // 举报来源
					content: "", // 举报内容
					attachments: [], // 举证资料
					attachmentsCount: "", // 举证资料附件数量，仅验证必填项使用
				},
                rules:{
                    name: [
                    {
                      required: true,
                      message: "姓名不能为空",
                      trigger: ["blur","change"],
                    },
					{ validator: validateName, trigger: ["blur","change"] }	
                  ],
                },
				// 举报类型
				typeList: [
					{
						value: 1,
						label: "行贿受贿索贿，吃拿卡要，利益输送",
					},
					{
						value: 2,
						label: "泄漏公司秘密，倒卖客户个人信息",
					},
					{
						value: 3,
						label: "违规参股、经营、兼职，实施关联交易或违反利益冲突限制行为",
					},
					{
						value: 4,
						label:
							"工程、采购、路由、场地租赁等项目中捞取回扣，在营销政策、网点补助中搞暗箱操作",
					},
					{
						value: 5,
						label: "以各种名目变相敛财行为",
					},
					{
						value: 6,
						label: "赌博、涉黄、涉毒行为",
					},
					{
						value: 7,
						label:
							"职务侵占、盗窃、挪用资金，及徇私舞弊损害公司利益等违法违纪行为",
					},
					{
						value: 8,
						label: "铺张浪费、生活腐化、败坏风气，损害公司品牌、形象行为",
					},
					{
						value: 9,
						label: "失职、渎职行为",
					},
					{
						value: 10,
						label: "其他违法违纪行为",
					},
				],
				// 附件上传设置
				fileSetting: {
					size: 1024 * 1024 * 20, // 附件大小限制20M
					format: "gif,jpg,png,jpeg,bmp,doc,ppt,xls,xlsx,docx,pptx,zip,rar,pdf", // 附件类型限制
					length: 1000,
				},
				saveStatus: false,
			};
		},
		methods: {
			// 下一步
			handleNext() {
				if (this.formObj.checked) {
					this.step = 2;
				} else {
					this.$message.warning("请阅读并确认以上信息，勾选后发起廉政举报");
				}
			},
			// 上一步
			handlePrev() {
				this.step = 1;
			},
			// 举证资料上传
			handleSuccess(res, file, fileList) {
				if (res.data.code === 200) {
					this.formObj.attachmentsCount =
						fileList && fileList.length > 0 ? fileList.length : "";
					this.formObj.attachments.push({
						attachmentName: file.name,
						url: res.data.data.url,
					});
					this.$message.success(`文件 ${file.name} 上传成功`);
				}
			},
			handleRemove(file, fileList) {
				this.formObj.attachmentsCount =
					fileList && fileList.length > 0 ? fileList.length : "";
				this.formObj.attachments = fileList.map((item, index) => {
					return {
						attachmentName: item.name,
						url: item.response.data.data.url,
					};
				});
			},
			beforeRemove(file) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			handleBeforeupload(file) {
				if (
					this.fileSetting.format.indexOf(this.formatFile(file.name, 2)) == -1
				) {
					this.$message.warning("文件格式不支持");
					return false;
				}
				if (file.size > this.fileSetting.size) {
					this.$message.warning("仅支持上传20M以内的文件");
					return false;
				}
			},
			checkPhone() {
				var that = this;
				var status = false;
				var reg = /^(1[3-9][0-9])\d{8}$/;
				if (
					that.formObj.reporterPhone1 &&
					!reg.test(that.formObj.reporterPhone1)
				) {
					status = true;
				}

        for (var i = 0; i < that.formObj.list.length; i++) {
          let phoneArr = that.formObj.list[i].phone.split(/[\n\s+,，；;]/g)
          for (let item of phoneArr){
            if (item && !reg.test(item)) {
              status = true;
            }
          }
        }

				return status;
			},
			checkWeChat() {
				var that = this;
				var status = false;
				var reg = /^[A-Za-z0-9]+$/;
				if (
					that.formObj.reporterWeChat &&
					!reg.test(that.formObj.reporterWeChat)
				) {
					status = true;
				}

				for (var i = 0; i < that.formObj.list.length; i++) {
					if (
						that.formObj.list[i].weChat &&
						!reg.test(that.formObj.list[i].weChat)
					) {
						status = true;
					}
				}

				return status;
			},
			// 确认提交
			submitForm(formName) {
				var that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.checkPhone()) {
							this.$message.warning(
								"请输入正确的联系电话，联系电话由11位数字组成"
							);
							return false;
						}
						if (that.checkWeChat()) {
							this.$message.warning(
								"请输入正确的微信号，微信号由数字和英文字母组成"
							);
							return false;
						}
						that.saveStatus = true;
						that.$http
							.post(
								that.baseUrl + "/incorruptible/accusation/accusation/save?t=2",
								that.formObj
							)
							.then(function (res) {
								if (res.data && res.data.data && res.data.data.code === 200) {
									setTimeout(() => {
										that.step = 3;
										that.saveStatus = false;
									}, 1000);
								}else {
									that.$message.warning(res.data.data.message);
								    that.saveStatus = false;
								}
							})
							.catch(function (error) {
								console.log(error);
								that.saveStatus = false;
							});
					} else {
						this.$message.warning("请完善举报信息，* 表示必填项");
						return false;
					}
				});
			},
			reloadPage() {
				window.location.reload();
			},

			formatFile(fileName) {
				return fileName
					? fileName.split(".").pop().toLocaleLowerCase() || ""
					: "";
			},
		},
	};
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>
